"use strict";

var filterL = require("./filterL.js");

var curry2 = require("../Strict/curry2.js");

var take = require("../Strict/take.js");

var go1 = require("../Strict/go1.js");

module.exports = curry2(function intersectionWithL(f, iter1, iter2) {
  return filterL(a => go1(take(1, filterL(b => f(a, b), iter2)), b => b.length), iter1);
});